export default {
  FETCH_QUEUE_MISSED: (state, payload) => {
    state.queueMissed = payload
  }
}